import { combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import headerSlice from './slices/headerSlice';
import rightDrawerSlice from '../store/slices/rightDrawerSlice';
import modalSlice from '../store/slices/modalSlice';
import { persistReducer } from 'redux-persist';
import departmentReducer from './slices/department';
import { leadsSlice } from './slices/leadSlice';
import userReducer from './slices/userSlice';
import projectsReducer from './slices/projectsSlice';
import tasksReducer from './slices/tasksSlice';
import discussionsReducer from './slices/discussionsSlice';

const rootPersistConfig = {
  key: 'root',
  storage,
  blacklist: ['auth']
};

const departmentPersistConfig = {
  key: 'department',
  storage,
}
const userPersistConfig = {
  key: 'users',
  storage,
}
const projectsPersistConfig = {
  key: 'projects',
  storage,
}
const tasksPersistConfig = {
  key: 'tasks',
  storage,
}
const discussionsPersistConfig = {
  key: 'discussions',
  storage,
}


const rootReducer = combineReducers({
  header: headerSlice,
  rightDrawer: rightDrawerSlice,
  modal: modalSlice,
  lead: leadsSlice,
  // Add department reducer here with persistence
  department: persistReducer(departmentPersistConfig, departmentReducer), 
  users: persistReducer(userPersistConfig, userReducer), 
  projects: persistReducer(projectsPersistConfig, projectsReducer),
  tasks: persistReducer(tasksPersistConfig, tasksReducer),
  discussions: persistReducer(discussionsPersistConfig, discussionsReducer),
});

// The rootReducer is passed as the second argument here
export const persistedReducer = persistReducer(rootPersistConfig, rootReducer);
